import { Stack } from "@chakra-ui/react";
import { KYDAdminFeedItem } from "@common/interfaces/KYDOrganization";
import LinkInput from "./LinkInput";
import ImageUploadInputWithPreview from "./ImageUploadInputWithPreview";
import actions from "../../actions";

const NewsForm = ({
  loading,
  updateLoading,
  updateDirtyText,
  dirtyText,
  label,
  feedItem,
}: {
  loading: { link: boolean; tickettype: boolean };
  updateLoading: (id: string, state: boolean) => void;
  label: string;
  updateDirtyText: (input: Record<string, any>) => void;
  dirtyText: Record<string, any>;
  feedItem: KYDAdminFeedItem | null;
}) => {
  return (
    <Stack>
      <LinkInput
        updateDirtyText={updateDirtyText}
        feedItem={feedItem}
        valueFrom="title"
        dirtyText={dirtyText}
        label={label}
        isDisabled={loading["link"] || loading["link.preview"]}
      />
      <ImageUploadInputWithPreview
        updateLoading={updateLoading}
        dirtyText={dirtyText}
        onFileUploaded={({ fileKey, cdn_url }) => {
          updateDirtyText({ "item.image_override_preview": cdn_url });
          updateDirtyText({ "item.image_override": fileKey });
        }}
        feedItem={feedItem}
        isDisabled={loading["link"]}
        createUploadUrl={(file, callback) =>
          actions.ADMIN.createPublicUploadUrl(file, callback)
        }
      />
    </Stack>
  );
};

export default NewsForm;
